/** AADE Φ2 / myDATA VAT declaration field codes. */

export type VatCodeGroup =
  | 'output'
  | 'outputVat'
  | 'input'
  | 'inputVat'
  | 'adjustment'
  | 'other';

/** High-level split for UI: sales vs purchases. */
export type VatCodeSide = 'sales' | 'purchases' | 'adjustment' | 'other';

const OUTPUT_BASE = new Set([
  '301',
  '302',
  '303',
  '304',
  '305',
  '306',
  '308',
  '309',
  '310',
  '311',
  '312',
  '313',
  '314',
  '315',
  // Zero-rated / exempt outflows (taxable base, not VAT euros)
  '342',
  '345',
  '348',
  '349',
]);
const OUTPUT_VAT = new Set([
  '331',
  '332',
  '333',
  '334',
  '335',
  '336',
  '338',
  '339',
]);
const INPUT_BASE = new Set(['361', '362', '363', '364', '365', '366']);
const INPUT_VAT = new Set(['381', '382', '383', '384', '385', '386']);

export function vatCodeGroup(code: string): VatCodeGroup {
  if (OUTPUT_BASE.has(code)) return 'output';
  if (OUTPUT_VAT.has(code)) return 'outputVat';
  if (INPUT_BASE.has(code)) return 'input';
  if (INPUT_VAT.has(code)) return 'inputVat';
  return 'other';
}

export function vatCodeSide(code: string): VatCodeSide {
  const group = vatCodeGroup(code);
  if (group === 'output' || group === 'outputVat') return 'sales';
  if (group === 'input' || group === 'inputVat') return 'purchases';
  return 'other';
}

export function formatVatCodeLabel(
  code: string,
  labels: { vatCode: string; vatCodeLabels: Record<string, string> },
): string {
  const desc = labels.vatCodeLabels[code];
  return desc ? `${code} · ${desc}` : `${labels.vatCode} ${code}`;
}
